import { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router';
import { useQuery } from '@apollo/client/react';

import { CompanyDocument } from 'src/graphql/actions/company/company.query';
import { useAuth } from 'src/context/auth/use-auth';
import { saveReturnTo } from 'src/utils/return-to';

const ProtectedRoute = ({ children }: React.PropsWithChildren) => {
  const { inProgress, isSignedIn } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { data, loading: isLoading } = useQuery(CompanyDocument, {
    fetchPolicy: 'cache-and-network',
    skip: inProgress,
  });

  useEffect(() => {
    if (!data) return;

    const requiredFields = [
      data.company.companyName,
      data.company.street,
      data.company.city,
      data.company.postalCode,
      data.company.country,
    ];

    if (requiredFields.some((field) => !field)) navigate('/onboarding');
  }, [data, navigate]);

  if (inProgress || isLoading) {
    return <></>;
  }

  if (!isSignedIn) {
    saveReturnTo(location.pathname + location.search + location.hash);
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
